<button class="btn btn-sm btn-danger" (click)="removeInvitation($event)">
    <nb-icon icon="fa-times"></nb-icon>
</button>
